import { formatDateTime } from './date/formatDateTime'
import { getEnumDisplayValue } from './enum/getDisplayValue'
import { getReferenceDisplayValue } from './reference'
import { SchemaAttribute } from '@/Data/typesV2'

export const getAttributeDisplayValue = (
  attribute?: SchemaAttribute,
  attributeValue?: unknown,
) => {
  if (attributeValue === null || attributeValue === undefined) return ''

  if (attribute?.type === 'boolean') {
    return (attributeValue as boolean).toString()
  }

  if (attribute?.type === 'string') {
    return attributeValue as string
  }

  if (attribute?.type === 'number') {
    return new Intl.NumberFormat('en', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      useGrouping: false,
    }).format(attributeValue as number)
  }

  if (attribute?.type === 'enum' || attribute?.type === 'enumarray') {
    return getEnumDisplayValue(attribute.enumValues, attributeValue)
  }

  if (attribute?.type === 'date' || attribute?.type === 'datetime') {
    return formatDateTime(attributeValue)
  }

  if (attribute?.type === 'reference') {
    const { referenceTo, referenceFilter } = attribute
    return getReferenceDisplayValue(
      attributeValue,
      referenceTo,
      referenceFilter,
    )
  }
}
